import { useEffect } from 'react';

export const useRedirectOnBack = (redirectStep?: number) => {
  useEffect(() => {
    if (redirectStep) {
      const handlePopState = () => {
        history.go(redirectStep);
      };

      window.onpopstate = handlePopState;

      history.pushState({}, '');
    }

    return () => {
      if (redirectStep) {
        window.onpopstate = null;
      }
    };
  }, [redirectStep]);
};
